import clsx from 'clsx'
import styles from './FadeScrollContainer.module.scss'
import React, {ReactNode, useEffect, useRef} from 'react'

interface FadeScrollContainerProps {
    fadeWidth: number
    className?: string
    children: ReactNode
}

export const FadeScrollContainer = ({
    fadeWidth,
    className,
    children,
}: FadeScrollContainerProps) => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const el = ref.current
        if(!el) return

        const updateFades = () => {
            const maxScrollLeft = el.scrollWidth - el.clientWidth
            const hasOverflow = maxScrollLeft > 0

            if(!hasOverflow) {
                el.style.removeProperty('--fade-left')
                el.style.removeProperty('--fade-right')
                return
            }

            const leftFadeWidth = Math.min(el.scrollLeft, fadeWidth)
            const rightFadeWidth = Math.min(maxScrollLeft - el.scrollLeft, fadeWidth)

            el.style.setProperty('--fade-left', `${leftFadeWidth}px`)
            el.style.setProperty('--fade-right', `${rightFadeWidth}px`)
        }

        updateFades()

        el.addEventListener('scroll', updateFades, {passive: true})

        const resizeObserver = new ResizeObserver(updateFades)
        resizeObserver.observe(el)

        return () => {
            el.removeEventListener('scroll', updateFades)
            resizeObserver.disconnect()
        }
    }, [fadeWidth])

    return (
        <div ref={ref} className={clsx(styles.container, className)}>
            {children}
        </div>
    )
}
